import { Link, NavLink } from "react-router-dom";
import AudioToggle from "./AudioToggle";

function Layout({ children }) {
  return (
    <div className="museum-bg min-h-screen text-museum-bone">
      <div className="grain-overlay" />
      <div className="fog-layer fixed z-0" />
      <div className="relative z-10 flex min-h-screen flex-col">
        <header className="sticky top-0 z-40 border-b border-museum-bone/10 bg-museum-black/75 backdrop-blur-xl">
          <nav className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-5 py-4 lg:px-8" aria-label="Main navigation">
            <Link to="/" className="font-display text-lg text-museum-bone transition hover:text-museum-gold">
              Museum of Human Fears
            </Link>
            <div className="flex items-center gap-5 text-sm text-museum-muted">
              <NavLink to="/" className={({ isActive }) => `transition hover:text-museum-bone ${isActive ? "text-museum-gold" : ""}`}>
                Gallery
              </NavLink>
              <NavLink to="/about" className={({ isActive }) => `transition hover:text-museum-bone ${isActive ? "text-museum-gold" : ""}`}>
                About
              </NavLink>
            </div>
          </nav>
        </header>
        <main className="flex-1">{children}</main>
        <footer className="relative border-t border-museum-bone/10 bg-museum-black/70">
          <div className="mx-auto flex w-full max-w-7xl flex-col gap-5 px-5 py-8 md:flex-row md:items-center md:justify-between lg:px-8">
            <div>
              <p className="font-display text-xl text-museum-bone">Museum of Human Fears</p>
              <p className="mt-2 max-w-xl text-sm text-museum-muted">A digital exhibition about the quiet architecture of fear.</p>
            </div>
            <AudioToggle />
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Layout;
